import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintsocial = () => {
  const title = "{BRAND.domainLabel} runs a focus group with 25 under 18s on social media, challenges and rhetoric and views on {BRAND.short}."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on July, 2024</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                On 14th August, {BRAND.domainLabel} ran a focus group with 25 teenagers
                (all under 18s) focusing on the themes of social media,
                challenges and rhetorics. We were keen to get insight on how
                they viewed the relevance of a new social media platform like
                {BRAND.domainLabel}.
              </p>

              <p>
                The session provided a chance for the founders, Andrew and
                Harleen Ahluwalia-Cook, to gain insight into the strong desire
                teenagers have for a future world characterised by kindness,
                acceptance, and the removal of online hate. While participants
                recognised the positives of social media — connection,
                creativity, music discovery, and news — they voiced significant
                concerns about harmful content, trolling, grooming, and endless
                “doom-scrolling.”
              </p>

              <p>Key findings include:</p>

              <ul>
                <li>
                  <b>Safety and Moderation:</b> Young people welcomed {BRAND.short}’s
                  age-gating, safeguarding, and pre-moderation of posts, seeing
                  it as reassuring for both themselves and their parents. Many
                  felt this could improve trust between parents and children.
                </li>
                <li>
                  <b>Platform Experience:</b> The clean, calming interface,
                  values-based profiles, and recognition features such as badges
                  were highly rated, with participants saying it “felt adult”
                  and more authentic than existing cluttered platforms.
                </li>
                <li>
                  <b>Healthy Engagement:</b> Features such as the “no comments”
                  model, morning news updates from Rudi the chatbot, and
                  value-aligned quizzes were seen as positive alternatives to
                  traditional social media mechanics that often drive negativity
                  or addiction.
                </li>
                <li>
                  <b>Subscription Fee:</b> Most participants were open to a
                  subscription model, recognising its role in funding moderation
                  and charitable donations, with some suggesting student
                  discounts to ensure accessibility.
                </li>
                <li>
                  <b>Social Media Education:</b> Both groups highlighted the
                  lack of meaningful social media education in schools, with
                  existing teaching seen as overly negative and disconnected
                  from real experiences.
                </li>
              </ul>

              <p>
                The research also highlighted that young people want social
                media to move away from algorithm- driven echo chambers and
                follower counts, instead offering a more authentic,
                values-driven space. These focus groups confirmed that young
                people are seeking safer, kinder, and more constructive online
                spaces. Their feedback reinforces our commitment to building a
                platform where time online feels valuable, relationships are
                strengthened, and positivity is prioritised.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintsocial;
